"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ReduxFormConnect = exports.DynamicForm = void 0;
exports.onSubmitFail = onSubmitFail;
exports.shouldError = shouldError;
var _classnames = _interopRequireDefault(require("classnames"));
var _get = _interopRequireDefault(require("lodash/get"));
var _includes = _interopRequireDefault(require("lodash/includes"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _isObject = _interopRequireDefault(require("lodash/isObject"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _errorCodeConstants = _interopRequireDefault(require("../../constants/errorCodeConstants"));
var _Button = require("../../elements/button/Button");
var _getTouchedFormFields = _interopRequireDefault(require("../../form/helpers/getTouchedFormFields"));
var _isFormMounted = _interopRequireDefault(require("../../form/helpers/isFormMounted"));
var _validate = _interopRequireDefault(require("../../form/validation/validate"));
var _formActionConstants = require("../../redux/actions/form/formActionConstants");
var _staticContentPropCheck = _interopRequireDefault(require("../../utils/content/staticContentPropCheck"));
var _env = _interopRequireDefault(require("../../utils/env/env"));
var _FormErrorSummaryLink = _interopRequireDefault(require("../form-error-summary-link/FormErrorSummaryLink"));
var _FormField = _interopRequireDefault(require("../form-field/FormField"));
var _Message = require("../message/Message");
var _FormAutoFill = _interopRequireDefault(require("./_dev/FormAutoFill"));
var _formModule = _interopRequireDefault(require("./form.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["id", "name", "component", "fieldExtra"],
  _excluded2 = ["config", "handleOnChange", "handleSubmit", "onSubmit", "submitButtonClassName", "submitButtonLevel", "hideSubmitButton", "method", "action", "normalForm", "enableBrowserValidation", "formValidationErrorsAlertMessageId", "hideFirstErrorLink", "scrollValidationMessageIntoView"],
  _excluded3 = ["component", "name", "fields", "legend", "radioGroup"],
  _excluded4 = ["name", "fields", "legend"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getKey = function getKey(fieldConfig) {
  var key = fieldConfig.name;
  if (fieldConfig.type === 'radio') {
    key = "".concat(fieldConfig.name, "_").concat(fieldConfig.radioValue);
  }
  return key;
};
var DynamicForm = exports.DynamicForm = /*#__PURE__*/function (_PureComponent) {
  function DynamicForm(props) {
    var _this;
    _classCallCheck(this, DynamicForm);
    _this = _callSuper(this, DynamicForm, [props]);
    _this.state = {
      disabled: _this.props.disabled,
      submitting: _this.props.submittingOverride || _this.props.submitting,
      formValidationError: undefined
    };
    return _this;
  }

  // https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/issues/228
  _inherits(DynamicForm, _PureComponent);
  return _createClass(DynamicForm, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
        useFormValidationErrorsAlertMessage = _this$props.useFormValidationErrorsAlertMessage,
        submitFailed = _this$props.submitFailed,
        formSubmitValidationFailures = _this$props.formSubmitValidationFailures;
      var formValidationError = this.state.formValidationError;
      var isSubmitting = nextProps.submittingOverride || nextProps.submitting;
      if (!nextProps.submitFailed) {
        this.setState({
          disabled: nextProps.disabled,
          submitting: isSubmitting,
          formValidationError: undefined
        });
      } else {
        var initialSubmitFail = !submitFailed && nextProps.submitFailed;
        var formSubmitValidationFailuresChanged = formSubmitValidationFailures !== nextProps.formSubmitValidationFailures;
        var subsequentSubmitFail = submitFailed && nextProps.submitFailed && formSubmitValidationFailuresChanged;
        var validationError = formValidationError ? _objectSpread(_objectSpread({}, formValidationError), DynamicForm.getFormValidationErrorMessage(nextProps)) : undefined;
        if (useFormValidationErrorsAlertMessage && (nextProps.totalValidationErrors || nextProps.formSubmitErrors) && (initialSubmitFail || subsequentSubmitFail)) {
          validationError = _objectSpread(_objectSpread({}, DynamicForm.getFormValidationErrorMessage(nextProps)), {}, {
            code: _errorCodeConstants["default"].CLIENT_FORM_VALIDATION_ERRORS,
            refreshes: nextProps.formSubmitValidationFailures
          });
        }
        if (!nextProps.totalValidationErrors && !nextProps.formSubmitErrors) {
          validationError = undefined;
        }
        this.setState({
          disabled: nextProps.disabled,
          submitting: isSubmitting,
          formValidationError: validationError
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        submitFailed = _this$props2.submitFailed,
        onSubmitFailed = _this$props2.onSubmitFailed;
      if (!prevProps.submitFailed && submitFailed) {
        onSubmitFailed();
      }
    }
  }, {
    key: "renderFormField",
    value: function renderFormField(_ref) {
      var config = _ref.config,
        fieldConfig = _ref.fieldConfig,
        disabled = _ref.disabled,
        submitting = _ref.submitting,
        submitButton = _ref.submitButton;
      var id = fieldConfig.id,
        name = fieldConfig.name,
        component = fieldConfig.component,
        fieldExtra = fieldConfig.fieldExtra,
        allOtherFieldConfigProps = _objectWithoutProperties(fieldConfig, _excluded);
      var change = this.props.change;
      var key = getKey(fieldConfig);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reduxForm.Field, _objectSpread({
        id: id,
        name: name,
        component: _FormField["default"],
        element: component,
        formId: config.id,
        disabled: disabled || submitting,
        setFieldValue: change,
        submitButton: config.submitButtonInlineFieldId === id ? submitButton : undefined,
        extra: fieldExtra ? /*#__PURE__*/(0, _jsxRuntime.jsx)(fieldExtra.component, _objectSpread({
          action: fieldExtra.action,
          disabled: disabled || submitting
        }, fieldExtra.props), getKey(fieldExtra)) : undefined
      }, allOtherFieldConfigProps), key);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        config = _this$props3.config,
        handleOnChange = _this$props3.handleOnChange,
        handleSubmit = _this$props3.handleSubmit,
        onSubmit = _this$props3.onSubmit,
        submitButtonClassName = _this$props3.submitButtonClassName,
        submitButtonLevel = _this$props3.submitButtonLevel,
        hideSubmitButton = _this$props3.hideSubmitButton,
        method = _this$props3.method,
        action = _this$props3.action,
        normalForm = _this$props3.normalForm,
        enableBrowserValidation = _this$props3.enableBrowserValidation,
        formValidationErrorsAlertMessageId = _this$props3.formValidationErrorsAlertMessageId,
        hideFirstErrorLink = _this$props3.hideFirstErrorLink,
        scrollValidationMessageIntoView = _this$props3.scrollValidationMessageIntoView,
        allOtherProps = _objectWithoutProperties(_this$props3, _excluded2);
      if (!config) {
        return null;
      }
      var _this$state = this.state,
        disabled = _this$state.disabled,
        submitting = _this$state.submitting,
        formValidationError = _this$state.formValidationError;
      var submitButtonExtra = config.submitButtonExtra;
      var showSubmitButton = !hideSubmitButton && !config.submitButtonInlineFieldId && config.submitButton;
      var submitButtonContent = config.submitButton;
      var ButtonComponent;
      switch (submitButtonLevel) {
        case 'secondary':
          ButtonComponent = _Button.SecondaryButton;
          break;
        case 'underlined':
          ButtonComponent = _Button.UnderlinedButton;
          break;
        case 'tertiary':
          ButtonComponent = _Button.TertiaryButton;
          break;
        case 'primary':
        default:
          ButtonComponent = _Button.PrimaryButton;
      }
      var submitButton = /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonComponent, {
        id: config.id,
        className: submitButtonClassName,
        type: "submit",
        disabled: disabled,
        submitting: submitting,
        "data-testid": "".concat(config.id, "-submit"),
        children: submitButtonContent
      });
      var FormComponent = normalForm ? 'form' : _reduxForm.Form;
      var commonMessageProps = formValidationError ? {
        type: 'error',
        title: formValidationError.title,
        body: formValidationError.body,
        code: formValidationError.code,
        id: formValidationErrorsAlertMessageId,
        className: (0, _classnames["default"])(_formModule["default"].errorContainer, _formModule["default"].message, _defineProperty({}, _formModule["default"].hiddenLink, hideFirstErrorLink))
      } : undefined;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(FormComponent, _objectSpread(_objectSpread(_objectSpread({
        className: _formModule["default"].form,
        form: config.id,
        onChange: handleOnChange
      }, !normalForm && {
        onSubmit: handleSubmit(onSubmit)
      }), !enableBrowserValidation && {
        noValidate: true
      }), {}, {
        method: method,
        action: action,
        "data-testid": allOtherProps['data-testid'],
        "data-jlds": true,
        children: [formValidationError && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Message.Message, _objectSpread(_objectSpread({}, commonMessageProps), {}, {
          dataId: "".concat(config.id, "-error-message"),
          dataTestId: "form-validation-error-message",
          scrollToMessageOnMount: scrollValidationMessageIntoView
        })), /* NOTE: This will not render in production */
        _env["default"].isClientNonProd && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormAutoFill["default"], {
          id: config.id
        }), (0, _get["default"])(config, 'fields', []).map(function (fieldConfig) {
          if (fieldConfig) {
            // extras are components that are rendered as part of the <form> element,
            // but not registered with redux-form
            // they can be static elements or interactive elements that can perform
            // an action property that is passed from the parent via the config
            // eg: this action could result in the form re-rendering with new config
            if (fieldConfig.extra) {
              var _fieldConfig$props;
              var extraClassName = (0, _classnames["default"])(fieldConfig.name === 'form-inline-message' ? _formModule["default"].inlineMessage : undefined, (_fieldConfig$props = fieldConfig.props) === null || _fieldConfig$props === void 0 ? void 0 : _fieldConfig$props.className);
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(fieldConfig.component, _objectSpread(_objectSpread({
                action: fieldConfig.action,
                disabled: disabled || submitting
              }, fieldConfig.props), {}, {
                className: extraClassName
              }), getKey(fieldConfig));
            }

            // a fieldset of RadioButton inputs... render using redux-form <Fields>
            if (fieldConfig.radioGroup) {
              var component = fieldConfig.component,
                name = fieldConfig.name,
                fields = fieldConfig.fields,
                legend = fieldConfig.legend,
                radioGroup = fieldConfig.radioGroup,
                allOtherFieldConfigProps = _objectWithoutProperties(fieldConfig, _excluded3);
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reduxForm.Fields, _objectSpread({
                name: name,
                radioGroup: radioGroup,
                legend: legend,
                component: component,
                names: fields.map(function (el) {
                  return el.name;
                }),
                fields: fields,
                disabled: disabled || submitting
              }, allOtherFieldConfigProps), getKey(fieldConfig));
            }

            // a fieldset... render as <FormFields> inside fieldConfig.component
            if (fieldConfig.fieldset) {
              var _name = fieldConfig.name,
                _fields = fieldConfig.fields,
                _legend = fieldConfig.legend,
                _allOtherFieldConfigProps = _objectWithoutProperties(fieldConfig, _excluded4);
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(fieldConfig.component, _objectSpread(_objectSpread({
                legend: _legend,
                name: _name
              }, _allOtherFieldConfigProps), {}, {
                children: _fields.map(function (fieldConfig) {
                  return _this2.renderFormField({
                    config: config,
                    fieldConfig: fieldConfig,
                    disabled: disabled,
                    submitting: submitting,
                    submitButton: submitButton
                  });
                })
              }), getKey(fieldConfig));
            }

            // regular <FormField>
            return _this2.renderFormField({
              config: config,
              fieldConfig: fieldConfig,
              disabled: disabled,
              submitting: submitting,
              submitButton: submitButton
            });
          }
          return null;
        }), showSubmitButton && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _formModule["default"].formSubmitButtonContainer,
          children: [submitButton, submitButtonExtra && /*#__PURE__*/(0, _jsxRuntime.jsx)(submitButtonExtra.component, _objectSpread({
            disabled: disabled || submitting
          }, submitButtonExtra.props), getKey(submitButtonExtra))]
        })]
      }));
    }
  }], [{
    key: "setFormSubmitValidationFailures",
    value: function setFormSubmitValidationFailures(formId) {
      var attempts = DynamicForm.formSubmitValidationFailures[formId] || 0;
      DynamicForm.formSubmitValidationFailures = _objectSpread(_objectSpread({}, DynamicForm.formSubmitValidationFailures), {}, _defineProperty({}, formId, attempts + 1));
    }
  }, {
    key: "getFormValidationErrorMessage",
    value: function getFormValidationErrorMessage(props) {
      var totalValidationErrors = props.totalValidationErrors,
        formValidationErrorsAlertMessage = props.formValidationErrorsAlertMessage,
        hideFirstErrorLink = props.hideFirstErrorLink,
        multiFormValidation = props.multiFormValidation;
      if (formValidationErrorsAlertMessage) {
        if ((0, _isObject["default"])(formValidationErrorsAlertMessage)) {
          return formValidationErrorsAlertMessage;
        }
        return {
          title: formValidationErrorsAlertMessage
        };
      }
      if (totalValidationErrors === 1) {
        return {
          title: "There's an error below, please correct this and try again.",
          body: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormErrorSummaryLink["default"], {
            hideFirstErrorLink: hideFirstErrorLink,
            totalValidationErrors: totalValidationErrors,
            multiFormValidation: multiFormValidation
          })
        };
      }
      return {
        title: "There are ".concat(totalValidationErrors, " errors below, please correct them and try again."),
        body: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormErrorSummaryLink["default"], {
          hideFirstErrorLink: hideFirstErrorLink,
          totalValidationErrors: totalValidationErrors,
          multiFormValidation: multiFormValidation
        })
      };
    }
  }]);
}(_react.PureComponent); // https://github.com/erikras/redux-form/issues/2971
_defineProperty(DynamicForm, "propTypes", {
  config: _propTypes["default"].shape({
    submitButton: _staticContentPropCheck["default"]
  }).isRequired,
  submittingOverride: _propTypes["default"].bool,
  onSubmit: _propTypes["default"].func,
  useFormValidationErrorsAlertMessage: _propTypes["default"].bool,
  formValidationErrorsAlertMessage: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
    title: _propTypes["default"].oneOfType([_propTypes["default"].string.isRequired, _propTypes["default"].array.isRequired]),
    body: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array])
  })]),
  formValidationErrorsAlertMessageId: _propTypes["default"].string,
  formSubmitValidationFailures: _propTypes["default"].number,
  submitButtonClassName: _propTypes["default"].string,
  submitButtonLevel: _propTypes["default"].string,
  formSyncErrors: _propTypes["default"].objectOf(_propTypes["default"].string),
  formSubmitErrors: _propTypes["default"].objectOf(_propTypes["default"].string),
  totalValidationErrors: _propTypes["default"].number,
  onSubmitFailed: _propTypes["default"].func,
  multiFormValidation: _propTypes["default"].bool,
  // from redux-form
  handleSubmit: _propTypes["default"].func.isRequired,
  handleOnChange: _propTypes["default"].func.isRequired,
  submitting: _propTypes["default"].bool.isRequired,
  submitFailed: _propTypes["default"].bool.isRequired,
  initialize: _propTypes["default"].func.isRequired,
  clearSubmit: _propTypes["default"].func.isRequired,
  change: _propTypes["default"].func,
  invalid: _propTypes["default"].bool,
  hideSubmitButton: _propTypes["default"].bool,
  normalForm: _propTypes["default"].bool,
  enableBrowserValidation: _propTypes["default"].bool,
  hideFirstErrorLink: _propTypes["default"].bool,
  scrollValidationMessageIntoView: _propTypes["default"].bool
});
_defineProperty(DynamicForm, "defaultProps", {
  submittingOverride: false,
  useFormValidationErrorsAlertMessage: true,
  formValidationErrorsAlertMessage: '',
  formValidationErrorsAlertMessageId: undefined,
  formSubmitValidationFailures: 0,
  submitButtonClassName: '',
  submitButtonLevel: 'primary',
  formSyncErrors: undefined,
  formSubmitErrors: undefined,
  multiFormValidation: false,
  totalValidationErrors: 0,
  onSubmit: function onSubmit() {},
  onSubmitFailed: function onSubmitFailed() {},
  // from redux-form
  change: function change() {},
  handleSubmit: function handleSubmit() {},
  handleOnChange: function handleOnChange() {},
  submitting: false,
  submitFailed: false,
  invalid: true,
  hideSubmitButton: false,
  normalForm: false,
  enableBrowserValidation: false,
  hideFirstErrorLink: false,
  scrollValidationMessageIntoView: false
});
_defineProperty(DynamicForm, "formSubmitValidationFailures", {});
function shouldError(_ref2) {
  var _ref2$nextProps = _ref2.nextProps,
    nextProps = _ref2$nextProps === void 0 ? {} : _ref2$nextProps,
    _ref2$props = _ref2.props,
    props = _ref2$props === void 0 ? {} : _ref2$props;
  var registeredFields = Object.keys((0, _get["default"])(props, 'registeredFields', {})).length;
  var nextRegisteredFields = Object.keys((0, _get["default"])(nextProps, 'registeredFields', {})).length;
  var registeredFieldsChanged = registeredFields !== nextRegisteredFields;
  var nextAnyTouched = (0, _get["default"])(nextProps, 'anyTouched', false);
  var nextInvalid = (0, _get["default"])(nextProps, 'invalid', false);
  var initValues = (0, _get["default"])(props, 'initialValues');
  var nextInitValues = (0, _get["default"])(nextProps, 'initialValues');
  var initValuesChanged = !(0, _isEqual["default"])(initValues, nextInitValues);
  return registeredFieldsChanged || nextAnyTouched || nextInvalid || initValuesChanged;
}
function onSubmitFail(errors, dispatch, submitError, props) {
  if (props.onFormSubmitFail) {
    props.onFormSubmitFail();
  }
  DynamicForm.setFormSubmitValidationFailures(props.form);
  // ensure form is re-rendered after DynamicForm.setFormSubmitValidationFailures is increased
  dispatch({
    type: _formActionConstants.FORM_REFRESH_ON_SUBMIT_FAIL
  });
}
var ReduxFormConnect = exports.ReduxFormConnect = (0, _reduxForm.reduxForm)({
  shouldError: shouldError,
  onSubmitFail: onSubmitFail,
  validate: _validate["default"]
})(DynamicForm);
var _default = exports["default"] = (0, _reactRedux.connect)(function (state, ownProps) {
  var formId = (0, _get["default"])(ownProps, 'config.id');
  var _ref3 = (0, _get["default"])(state.form, "".concat(formId), {}) || {},
    syncErrors = _ref3.syncErrors,
    submitErrors = _ref3.submitErrors;
  var formState = (0, _get["default"])(state, 'form');
  var totalValidationErrors = 0;
  if (ownProps.multiFormValidation && !(0, _isEmpty["default"])(formState)) {
    totalValidationErrors = Object.keys(formState).reduce(function (acc, formId) {
      var form = state.form[formId];
      if ((0, _isFormMounted["default"])(form)) {
        var touchedFields = (0, _getTouchedFormFields["default"])(form);
        var _syncErrors = form.syncErrors || {};
        Object.keys(_syncErrors).forEach(function (name) {
          if ((0, _includes["default"])(touchedFields, name)) {
            acc += 1;
          }
        });
        Object.keys(submitErrors || {}).forEach(function (name) {
          if ((0, _includes["default"])(touchedFields, name)) {
            acc += 1;
          }
        });
      }
      return acc;
    }, 0);
  } else if (syncErrors) {
    totalValidationErrors = Object.keys(syncErrors).length || 0;
  }
  return {
    formSubmitValidationFailures: DynamicForm.formSubmitValidationFailures[formId],
    formSubmitErrors: submitErrors,
    totalValidationErrors: totalValidationErrors,
    initialValues: ownProps.initialValues
  };
}, {
  forwardRef: true
})(ReduxFormConnect);